module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/a0ce155c968c9ac96c51b20ed4bd3dfe.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Emerald/Emerald3.svg
// module id = g5Dq
// module chunks = 1